import { styled } from '@linaria/react';

import { Text } from '~components/Typography';
import { CardButton } from '~shared/ui/organisms/CardButton';
import { MqTablet } from '~theme/media';

export const ImagesWrapper = styled.div`
	display: grid;
	justify-content: center;

	&.option1 {
		gap: 10px;
		grid-template-columns: repeat(2, 1fr);
	}

	&.option2 {
		gap: var(--gap-x3);
		grid-template-columns: repeat(2, 1fr);

		${MqTablet} {
			grid-template-columns: repeat(3, minmax(0, 375px));
		}
	}

	&.option3 {
		gap: 10px;
		grid-template-columns: repeat(2, minmax(0, 300px));
	}

	&.option4 {
		gap: var(--gap-l);
		grid-template-columns: repeat(2, minmax(0, 150px));

		${MqTablet} {
			gap: var(--gap-x6);
			grid-template-columns: repeat(4, minmax(0, 150px));
		}
	}

	&.option5 {
		gap: var(--gap-l);
		grid-template-columns: repeat(2, minmax(0, 150px));

		${MqTablet} {
			grid-template-columns: repeat(4, minmax(0, 180px));
		}
	}

	&.option6 {
		gap: var(--gap-l);
		grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));

		${MqTablet} {
			gap: var(--gap-x3);
		}
	}
`;

export const ExampleWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: 44rem;
	flex-direction: column;
	align-items: center;
	padding: 1.6rem;
	border: 1px solid var(--color-grey-19-solid);
	border-radius: var(--radius-s);
	gap: var(--gap-x2);
`;

export const ExampleMessage = styled(Text)`
	max-width: 70%;
	padding: 1rem 1.2rem;
	background: var(--color-white-xxs);

	&:nth-child(2n) {
		align-self: end;
		border-radius: var(--radius-xs) var(--radius-xs) 0 var(--radius-xs);
	}

	&:nth-child(2n + 1) {
		align-self: start;
		border-radius: var(--radius-xs) var(--radius-xs) var(--radius-xs) 0;
	}
`;

export const StyledCardButton = styled(CardButton)`
	width: 150px;

	&.option1 {
		width: 180px;
	}
`;
